import { BaseModel } from './base.model'
import { LessonSection } from './lesson-section.model'
import { Program } from './program.model'

export class Lesson extends BaseModel<Lesson> {
  static DEFAULT_ATTRIBUTES = {
    sections: []
  }

  comment: string
  folderId: number
  id: number
  name: string
  programs: Program[]
  sections: LessonSection[]
  state: string

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/lesson.model.ts